import React from 'react';
import { CSpinner } from '@coreui/react';

const Loader = ({ load }) => {

	if (load) {
		return (
			<div className="absolute-spinner">
				<CSpinner color="primary" size="sm" style={{ width: '3rem', height: '3rem' }} />
			</div>
		);
	}

	return null;
};

export default Loader;
